import AttributeStore from './attributeStore';

class SaleApartmentsAttributes extends AttributeStore {
  getAttributes () {
    return [
      {
        title: 'Характеристики ' + this.getCase(),
        items: [
          this.getFloor(),
          this.getSquareTotal(),
          this.getSquareLiving(),
          this.getSquareKitchen(),
          this.getPlaning(),
          this.getCorner(),
          this.getRenovation(),
          this.getWindowType(),
          this.getSanitary(),
          this.getBalcony(),
          this.getFloorCovering(),
          this.getOuterDoor(),
          this.getWindowView(),
          this.getIntercom(),
          this.getWaterMeter()
        ].filter(Boolean)
      },
      {
        title: 'Характеристики дома',
        items: [
          this.getBuildingType(),
          this.getNewBuilding(),
          this.getYearBuild(),
          this.getFloorTotal(),
          this.getCeilingHeight(),
          this.getMaterial(),
          this.getInternet(),
          this.getElevator(),
          this.getRubbishChute(),
          this.getParking()
        ].filter(Boolean)
      }
    ];
  }
}

export default SaleApartmentsAttributes;



// WEBPACK FOOTER //
// ./src/classes/announcement/attributes/saleApartmentsAttributes.js